import { API } from '../api'
import { intelligenceServiceUrl } from '../utils/constants'

export const getPTBDataForOpportunity = (
  partnerId: string,
  opportunityId: string
) => {
  return API.get(
    `${intelligenceServiceUrl}/partners/${partnerId}/ptb_report_by_opportunity_id/${opportunityId}`
  )
}

export const calculatePropensityScore = (
  partnerId: string,
  data: { prospect: string; opportunity_id?: string | null }[],
  userId?: string
) => {
  return API.post(
    `${intelligenceServiceUrl}/partners/${partnerId}/calculate_ptb`,
    { data },
    userId
      ? {
          params: {
            user_id: userId,
          },
        }
      : undefined
  )
}

export const fetchInferenceBatchStatus = (
  partnerId: string,
  inferenceId: string
) => {
  return API.get(
    `${intelligenceServiceUrl}/partners/${partnerId}/inference_batch_status/${inferenceId}`
  )
}

export const fetchUsersList = (partnerId: string) => {
  return API.get(`${intelligenceServiceUrl}/partners/${partnerId}/users_list`)
}
